// import React from "react";
import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Solutions from "../component/Solutions";
import ScrollFloat from "../component/ScrollFloat";
import { Helmet } from "react-helmet";
import ImageWithSkeleton from "../component/ImageWithSkeleton";

export default function Defi() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleItem = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const splitTextToSpans = (text, className = "") =>
    [...text].map((char, index) => (
      <span className={`char ${className}`} key={`${char}-${index}`}>
        {char === " " ? "\u00A0" : char}
      </span>
    ));

  // light dark change image

  const [theme, setTheme] = useState("light");

  useEffect(() => {
    const currentTheme =
      document.documentElement.getAttribute("data-theme") || "light";
    setTheme(currentTheme);

    const observer = new MutationObserver(() => {
      const newTheme =
        document.documentElement.getAttribute("data-theme") || "light";
      setTheme(newTheme);
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Helmet>
        <title>DeFi Development Services | Build DeFi Apps with Blockcryp</title>
        <meta
          name="description"
          content="Build secure and scalable DeFi applications with Blockcryp. We offer end-to-end DeFi development services including DEXs, staking, lending, and yield farming."
        />
        <meta
          name="keywords"
          content="DeFi development services, decentralized finance development, DeFi app development, DeFi smart contract development, DEX development company, DeFi staking platform development, DeFi lending platform solutions, yield farming development, DeFi protocol development, blockchain-based finance solutions"
        />
      </Helmet>
      {/* ---------- hreo section start ---------- */}
      <section className="token_hero space80">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-6 order-lg-1 order-2">
              <motion.h1
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="heading_h1 fw-bold"
              >
                Decentralized Finance{" "}
                <span className="text-primary"> DeFi Development </span>
              </motion.h1>
              <motion.p
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="pera_txt"
              >
                Connecting Networks of Collaborative Ecosystems to Drive
                Resiliency and Facilitate Trust with Exceptional DeFi
                Development Services
              </motion.p>
              <motion.p
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="pera_txt"
              >
                Want to unlock the gateway to the decentralized finance world
                for your business? As the most reliable and innovative force in{" "}
                <b> DeFi Development, </b> we craft powerful{" "}
                <b> DeFi Development Solutions </b> such as DEXs, lending
                platforms, staking, and yield farming protocols built for
                impact. Let’s lead the DeFi space and shape the decentralized
                financial landscape with our comprehensive assistance from
                launch to growth.
              </motion.p>
              <motion.button
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="button theme_btn mt-lg-4 mt-0"
                type="submit"
              >
                Hire a DeFi Expert!
              </motion.button>
            </div>
            <div className="col-lg-6 order-lg-2 order-1">
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <ImageWithSkeleton
                  src="assets/images/defi/defi_hero.webp"
                  alt=""
                  className="w-100"
                />
                {/* <img
                  src="assets/images/defi/defi_hero.webp"
                  alt="token hero"
                  className="w-100"
                /> */}
              </motion.div>
            </div>
          </div>
        </div>
      </section>
      {/* ---------- defi service section start ---------- */}
      <section className="space60">
        <div className="container">
          <ScrollFloat
            animationDuration={1}
            ease="back.inOut(2)"
            scrollStart="center bottom+=50%"
            scrollEnd="bottom bottom-=40%"
            stagger={0.09}
            textClassName="heading_h3 fw-semibold text-center mb-5"
          >
            <>
              {splitTextToSpans("  Welcome the DeFi Breakthrough with Our ")}{" "}
              <br className="d-none d-md-block"></br>
              {splitTextToSpans("DeFi Development Services", "text-primary")}
            </>
          </ScrollFloat>
          <div className="row g-4">
            <div className="col-lg-4 col-md-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="token_card"
              >
                <h5 className="heading_h5 fw-semibold">
                  DeFi Smart Contract Development
                </h5>
                <p>
                  We build secure, auditable <b> DeFi Smart Contracts </b> using
                  Solidity and Vyper. Our team ensures flawless execution,
                  automated logic, and zero vulnerabilities, empowering your
                  platform with trustless, tamper-proof financial transactions.
                </p>
              </motion.div>
            </div>
            <div className="col-lg-4 col-md-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="token_card"
              >
                <h5 className="heading_h5 fw-semibold">
                  DeFi Wallet Development
                </h5>
                <p>
                  We create intuitive, non-custodial <b> DeFi Wallets </b> with
                  multi-chain support and biometric security. Our tech ensures
                  asset control, private key protection, and seamless DeFi
                  interaction across platforms and protocols.
                </p>
              </motion.div>
            </div>
            <div className="col-lg-4 col-md-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="token_card"
              >
                <h5 className="heading_h5 fw-semibold">
                  Market Making Consulting
                </h5>
                <p>
                  Our consulting optimizes DeFi liquidity strategies using smart
                  algorithms, tokenomics, and DEX integrations. We help you
                  stabilize prices, boost trading volumes, and build a
                  sustainable market presence from day one.
                </p>
              </motion.div>
            </div>
            <div className="col-lg-4 col-md-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="token_card"
              >
                <h5 className="heading_h5 fw-semibold">DeFi App Development</h5>
                <p>
                  As a leading <b> DeFi development company, </b> we design
                  custom DeFi apps, from yield farming to lending, using
                  scalable architectures and secure APIs. Our apps are
                  mobile-responsive, gas-efficient, and user-centric, ready for
                  real-world DeFi adoption.
                </p>
              </motion.div>
            </div>
            <div className="col-lg-4 col-md-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="token_card"
              >
                <h5 className="heading_h5 fw-semibold">Token Development</h5>
                <p>
                  We develop fully compliant, utility, or governance tokens on
                  Ethereum, BNB Chain, and more. With audit-ready{" "}
                  <b> Smart Contract Development, </b> we ensure functionality,
                  interoperability, and ecosystem readiness for DeFi tokens.
                </p>
              </motion.div>
            </div>
            <div className="col-lg-4 col-md-6">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="token_card"
              >
                <h5 className="heading_h5 fw-semibold">DeFi DEX Development</h5>
                <p>
                  We build high-performance DEX platforms with AMM, order book,
                  or hybrid models. Our tech ensures seamless swaps, liquidity
                  pool integration, and secure smart contracts for
                  permissionless trading experiences.
                </p>
              </motion.div>
            </div>
          </div>
        </div>
      </section>
      {/* ---------- why choose defi section start ---------- */}
      <section className="space60 why_choose_defi">
        <div className="container">
          <div className="row justify-content-between g-4">
            <div className="col-xl-12 mb-5 text-center">
              <ScrollFloat
                animationDuration={1}
                ease="back.inOut(2)"
                scrollStart="center bottom+=50%"
                scrollEnd="bottom bottom-=40%"
                stagger={0.09}
                textClassName="heading_h3 fw-semibold text-center"
              >
                Why Choose Us as Your DeFi <br className="d-md-block d-none" /> Development Company
              </ScrollFloat>

              <motion.p
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                By partnering with Blockcryp, you can rely on a team of seasoned
                developers and finance experts{" "}
                <br className="d-none d-lg-block"></br> with real-world
                experience creating success stories.
              </motion.p>
            </div>
            <div className="col-xl-12">
              <div className="row justify-content-between">
                <div className="col-md-5">
                  <motion.div
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                  >
                    <h5 className="text_20 fw-semibold">
                      <i class="fa-solid fa-circle-check pe-2"></i>Blockchain
                      Pioneers
                    </h5>
                    <p className="fw-normal text-muted">
                      With years of experience in blockchain technology, we are
                      the industry pioneers with extensive expertise. We do one
                      thing, and we do it well.
                    </p>
                  </motion.div>
                </div>
                <div className="col-md-5">
                  <motion.div
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                  >
                    <h5 className="text_20 fw-semibold">
                      <i class="fa-solid fa-circle-check pe-2"></i>Customization
                      Excellence
                    </h5>
                    <p className="fw-normal text-muted">
                      We understand– No two businesses are the same, nor their
                      needs. We excel at tailoring solutions to your unique
                      requirements and vision.
                    </p>
                  </motion.div>
                </div>
                <div className="col-md-5">
                  <motion.div
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                  >
                    <h5 className="text_20 fw-semibold">
                      <i class="fa-solid fa-circle-check pe-2"></i>End-to-End
                      Services
                    </h5>
                    <p className="fw-normal text-muted">
                      We provide end-to-end services covering everything from
                      ideation and development to deployment with the utmost
                      professionalism and expertise.
                    </p>
                  </motion.div>
                </div>
                <div className="col-md-5">
                  <motion.div
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                  >
                    <h5 className="text_20 fw-semibold">
                      <i class="fa-solid fa-circle-check pe-2"></i>
                      Security-Centric Approach
                    </h5>
                    <p className="fw-normal text-muted">
                      Security is paramount in the crypto space so we adopt a
                      security-first mindset, implementing industry best
                      practices to safeguard your digital assets.
                    </p>
                  </motion.div>
                </div>
                <div className="col-md-5">
                  <motion.div
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                  >
                    <h5 className="text_20 fw-semibold">
                      <i class="fa-solid fa-circle-check pe-2"></i>Competitive
                      Pricing
                    </h5>
                    <p className="fw-normal text-muted">
                      We offer competitive pricing structures that ensure you
                      receive exceptional value for your investment without
                      compromising on quality.
                    </p>
                  </motion.div>
                </div>
                <div className="col-md-5">
                  <motion.div
                    initial={{ opacity: 0, x: 50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                  >
                    <h5 className="text_20 fw-semibold">
                      <i class="fa-solid fa-circle-check pe-2"></i>24/7 Support
                    </h5>
                    <p className="fw-normal text-muted">
                      We offer unwavering, ongoing support with 24/7
                      availability to ensure the longevity and optimal
                      performance of your blockchain solutions.
                    </p>
                  </motion.div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ---------- defi app development section start ---------- */}
      <section className="space60">
        <div className="container">
          <ScrollFloat
            animationDuration={1}
            ease="back.inOut(2)"
            scrollStart="center bottom+=50%"
            scrollEnd="bottom bottom-=40%"
            stagger={0.09}
            textClassName="heading_h3 fw-semibold text-center mb-xl-2 mb-5"
          >
            <>
              {splitTextToSpans("Real Benefits of DeFi")} <br className="d-md-block d-none" />
              {splitTextToSpans(" App Development", "text-primary")}
            </>
          </ScrollFloat>

          <div className="row align-items-center g-4">
            <div className="col-lg-6 order-lg-1 order-2">
              <motion.h3
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="heading_h3 fw-semibold mb-4"
              >
                Maximum Security
              </motion.h3>
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <h5 className="heading_h5 fw-semibold mb-1">
                  Securing DeFi Platforms :
                </h5>
                <p className="para_text p-2">
                  In our <b> Decentralized Finance (DeFi) Development, </b> we
                  build secure DeFi smart contracts using Solidity and Vyper.
                  Each contract is fully tested, auditable, and automated to
                  prevent tampering. This approach ensures flawless execution
                  and builds lasting trust in your <b> DeFi Development </b>{" "}
                  project.
                </p>
                <h5 className="heading_h5 fw-semibold mb-1">
                  Building Reliable DeFi Code :
                </h5>
                <p className="para_text p-2">
                  We design <b> DeFi Smart Contracts </b> as the core of your
                  decentralized finance (DeFi) development. With clean, secure
                  code in Solidity and Vyper, we automate financial functions
                  and eliminate vulnerabilities, creating dependable systems
                  that power your DeFi development with trust and efficiency.
                </p>
                <h5 className="heading_h5 fw-semibold mb-1">
                  Choose Us for DeFi Contracts :
                </h5>
                <p className="para_text p-2">
                  We specialize in creating <b> DeFi Smart Contracts </b> that
                  are secure, auditable, and trustless. By using Solidity and
                  Vyper, we eliminate risks and enable automated logic for
                  seamless financial processes, giving your platform a strong,
                  tamper-proof foundation users can rely on.
                </p>
              </motion.div>
            </div>
            <div className="col-lg-6 order-lg-2 order-1">
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <ImageWithSkeleton
                  src="assets/images/defi/benefit-1.webp"
                  alt=""
                  className="w-100"
                />
                {/* <img
                  src="assets/images/defi/benefit-1.webp"
                  alt=""
                  className="w-100"
                /> */}
              </motion.div>
            </div>
          </div>
        </div>
      </section>
      {/* ---------- Financial Inclusion section start ---------- */}
      <section className="space60">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-6">
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <ImageWithSkeleton
                  src="assets/images/defi/benefit-2.webp"
                  alt=""
                  className="w-100"
                />
                {/* <img
                  src="assets/images/defi/benefit-2.webp"
                  alt=""
                  className="w-100"
                /> */}
              </motion.div>
            </div>
            <div className="col-lg-6">
              <div>
                <motion.h3
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="heading_h3 fw-bold mb-4"
                >
                  Financial Inclusion
                </motion.h3>
                <motion.h5
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="heading_h5 fw-bold mb-1"
                >
                  DeFi Brings Finance to Everyone :
                </motion.h5>
                <motion.p
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="para_text p-2"
                >
                  DeFi gives global access to services like banking, lending,
                  and investing using just an internet connection. It removes
                  the barriers of traditional institutions, allowing underserved
                  populations to manage and grow their finances independently
                  through secure blockchain systems.
                </motion.p>
                <motion.h5
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="heading_h5 fw-bold mb-1"
                >
                  Unlocking Finance With DeFi Tools :
                </motion.h5>
                <motion.p
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="para_text p-2"
                >
                  With <b> DeFi Development Services, </b> anyone can access
                  financial tools like loans, savings, and investments without
                  needing a bank account. All that’s required is a digital
                  wallet and internet. This opens up life-changing opportunities
                  for those previously excluded from the traditional financial
                  world.
                </motion.p>
                <motion.h5
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="heading_h5 fw-bold mb-1"
                >
                  DeFi Empowers the Unbanked Globally :
                </motion.h5>
                <motion.p
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="para_text p-2"
                >
                  DeFi uses blockchain to offer borderless financial services.
                  It empowers people in remote or low-income areas by giving
                  them tools to save, invest, or borrow online. No paperwork, no
                  gatekeepers—just a free, open financial system available to
                  anyone, anytime, anywhere.
                </motion.p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ---------- Transparent Protocols section start ---------- */}
      <section className="space60">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-6 order-lg-1 order-2">
              <motion.h3
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="heading_h3 fw-semibold mb-4"
              >
                Transparent Protocols
              </motion.h3>
              <div>
                <motion.h5
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="heading_h5 fw-semibold mb-1"
                >
                  Transparent Rules in DeFi :
                </motion.h5>
                <motion.p
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="para_text p-2"
                >
                  Blockchain-based <b> DeFi Development </b> allows all
                  transaction rules to be publicly coded and viewable. This
                  ensures there are no hidden conditions, making platforms open,
                  secure, and accountable. It builds user trust by preventing
                  manipulation and allowing anyone to verify activities easily.
                </motion.p>
                <motion.h5
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="heading_h5 fw-semibold mb-1"
                >
                  Fully Auditable Systems :
                </motion.h5>
                <motion.p
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="para_text p-2"
                >
                  With <b> DeFi Development Solutions, </b> every action on the
                  platform is traceable and open to public inspection. These
                  solutions help eliminate opaque processes and build confidence
                  among users by ensuring that all financial activities follow
                  transparent and predefined logic.
                </motion.p>
                <motion.h5
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="heading_h5 fw-semibold mb-1"
                >
                  Trust in Every DeFi Step :
                </motion.h5>
                <motion.p
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="para_text p-2"
                >
                  <b> DeFi Smart Contracts </b> define how funds move, who can
                  access them, and under what conditions. Their open-source
                  nature ensures every rule is visible and immutable, making
                  systems honest and manipulation-free. This structure fosters
                  genuine trust among all participants.
                </motion.p>
              </div>
            </div>
            <div className="col-lg-6 order-lg-2 order-1">
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <ImageWithSkeleton
                  src="assets/images/defi/benefit-3.webp"
                  alt=""
                  className="w-100"
                />
                {/* <img
                  src="assets/images/defi/benefit-3.webp"
                  alt=""
                  className="w-100"
                /> */}
              </motion.div>
            </div>
          </div>
        </div>
      </section>
      {/* ---------- Cost Efficiency section start ---------- */}
      <section className="space60">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-6">
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <ImageWithSkeleton
                  src="assets/images/defi/benefit-4.webp"
                  alt=""
                  className="w-100"
                />
                {/* <img
                  src="assets/images/defi/benefit-4.webp"
                  alt=""
                  className="w-100"
                /> */}
              </motion.div>
            </div>
            <div className="col-lg-6">
              <div>
                <motion.h3
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="heading_h3 fw-bold mb-4"
                >
                  Cost Efficiency
                </motion.h3>
                <motion.h5
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="heading_h5 fw-bold mb-1"
                >
                  Streamline Finance with DeFi :
                </motion.h5>
                <motion.p
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="para_text p-2"
                >
                  DeFi removes the need for middlemen, cutting down on fees and
                  delays. By using smart contracts, financial actions like
                  lending or token swaps are automated. This makes processes
                  faster and safer. Businesses benefit greatly from DeFi,
                  gaining more control and transparency.
                </motion.p>
                <motion.h5
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="heading_h5 fw-bold mb-1"
                >
                  Automate Lending and Swapping :
                </motion.h5>
                <motion.p
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="para_text p-2"
                >
                  Smart contracts help automate core financial functions like
                  lending, borrowing, and asset trading without relying on banks
                  or brokers. This reduces costs and boosts efficiency. With
                  expert <b> DeFi Development Solutions, </b> companies can
                  build secure, scalable decentralized platforms.
                </motion.p>
                <motion.h5
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="heading_h5 fw-bold mb-1"
                >
                  Lower Costs with Smart Contracts :
                </motion.h5>
                <motion.p
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="para_text p-2"
                >
                  Traditional systems come with high fees and slow processing.{" "}
                  <b> DeFi Smart Contracts </b> fix this by running trusted
                  transactions automatically. These contracts enable fast,
                  low-cost operations like staking or exchanging assets—all
                  without centralized control or oversight.
                </motion.p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ---------- Interoperability section start ---------- */}
      <section className="space60">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-6 order-lg-1 order-2">
              <motion.h3
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="heading_h3 fw-semibold mb-4"
              >
                Interoperability
              </motion.h3>
              <div>
                <motion.h5
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="heading_h5 fw-semibold mb-1"
                >
                  Seamless Multi-Chain in DeFi :
                </motion.h5>
                <motion.p
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="para_text p-2"
                >
                  Modern <b> DeFi Development </b> enables smooth multi-chain
                  operations, allowing asset transfers across Ethereum, BNB
                  Chain, and Polygon. This flexibility helps users interact with
                  multiple ecosystems without limits, enhancing overall
                  blockchain usability.
                </motion.p>
                <motion.h5
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="heading_h5 fw-semibold mb-1"
                >
                  Multi-Chain Support Made Easy :
                </motion.h5>
                <motion.p
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="para_text p-2"
                >
                  With robust <b> DeFi Development Solutions, </b> platforms now
                  support cross-chain functionality. Users can move assets
                  seamlessly between networks, making the decentralized
                  experience more powerful, scalable, and inclusive.
                </motion.p>
                <motion.h5
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="heading_h5 fw-semibold mb-1"
                >
                  Powering DeFi Across Chains :
                </motion.h5>
                <motion.p
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="para_text p-2"
                >
                  Secure and automated <b> DeFi Smart Contracts </b> now drive
                  multi-chain support, letting users manage assets across
                  various blockchains efficiently. This improves performance,
                  trust, and interoperability across decentralized systems.
                </motion.p>
              </div>
            </div>
            <div className="col-lg-6 order-lg-2 order-1">
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <ImageWithSkeleton
                  src="assets/images/defi/benefit-5.webp"
                  alt=""
                  className="w-100"
                />
                {/* <img
                  src="assets/images/defi/benefit-5.webp"
                  alt=""
                  className="w-100"
                /> */}
              </motion.div>
            </div>
          </div>
        </div>
      </section>
      {/* ---------- Liquidity Optimization section start ---------- */}
      <section className="space60">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-6">
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <ImageWithSkeleton
                  src="assets/images/defi/benefit-6.webp"
                  alt=""
                  className="w-100"
                />
                {/* <img
                  src="assets/images/defi/bene-6.webp"
                  alt=""
                  className="w-100"
                /> */}
              </motion.div>
            </div>
            <div className="col-lg-6">
              <div>
                <motion.h3
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="heading_h3 fw-bold mb-4"
                >
                  Liquidity Optimization
                </motion.h3>
                <motion.h5
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="heading_h5 fw-bold mb-1"
                >
                  Yield Farming for Liquidity Growth :
                </motion.h5>
                <motion.p
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="para_text p-2"
                >
                  Yield farming helps users earn passive income by providing
                  liquidity to decentralized platforms. It plays a major role in
                  improving capital use within <b> DeFi Development, </b> making
                  it easier for users to maximize their holdings without
                  constant trading.
                </motion.p>
                <motion.h5
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="heading_h5 fw-bold mb-1"
                >
                  Staking Drives Steady Returns :
                </motion.h5>
                <motion.p
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="para_text p-2"
                >
                  Staking allows token holders to lock their assets and earn
                  rewards over time. It supports platform stability and user
                  engagement through secure DeFi smart contracts, encouraging
                  consistent returns with minimal risk in decentralized
                  environments.
                </motion.p>
                <motion.h5
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="heading_h5 fw-bold mb-1"
                >
                  AMMs Boost Capital Efficiency :
                </motion.h5>
                <motion.p
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="para_text p-2"
                >
                  Automated Market Makers (AMMs) enable instant, permissionless
                  trading by replacing traditional order books. This innovation
                  is a powerful part of DeFi, helping users benefit from
                  efficient asset swaps and greater liquidity access.
                </motion.p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ---------- Software Development section start ---------- */}
      <section className="space80 services">
        <div className="container">
          <ScrollFloat
            animationDuration={1}
            ease="back.inOut(2)"
            scrollStart="center bottom+=50%"
            scrollEnd="bottom bottom-=40%"
            stagger={0.09}
            textClassName="heading_h3 fw-semibold text-center mb-5"
          >
            <>
              {splitTextToSpans(" Real-Life Benefits of DeFi")} <br className="d-md-block d-none" />
              {splitTextToSpans(" Software Development", "text-primary")}
            </>
          </ScrollFloat>

          <div className="row justify-content-center g-4 pt-5">
            <div className="col-lg-4 col-sm-6">
              <motion.div
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
              >
                <div className="d-flex justify-content-center mb-3">
                  <img
                    src={
                      theme === "dark"
                        ? "assets/images/development/software1-dark.svg"
                        : "assets/images/development/software1-light.svg"
                    }
                    alt="Logo"
                  />
                </div>
                <h5 className="heading_h5">Process Simplification</h5>
                <p className="pera_txt">
                  DeFi reduces reliance on intermediaries, enabling direct
                  transactions between the participants.
                </p>
              </motion.div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <motion.div
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
              >
                <div className="d-flex justify-content-center mb-3">
                  <img
                    src={
                      theme === "dark"
                        ? "assets/images/development/software2-dark.svg"
                        : "assets/images/development/software2-light.svg"
                    }
                    alt="Logo"
                  />
                </div>
                <h5 className="heading_h5">Process Automation</h5>
                <p className="pera_txt">
                  Smart contracts enable organizations to automate and
                  accelerate their processes and services.
                </p>
              </motion.div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <motion.div
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
              >
                <div className="d-flex justify-content-center mb-3">
                  <img
                    src={
                      theme === "dark"
                        ? "assets/images/development/software3-dark.svg"
                        : "assets/images/development/software3-light.svg"
                    }
                    alt="Logo"
                  />
                </div>
                <h5 className="heading_h5">Reduced Transaction Cost</h5>
                <p className="pera_txt">
                  Peer-to-peer transactions between the participants reduce the
                  transaction cost.
                </p>
              </motion.div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <motion.div
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
              >
                <div className="d-flex justify-content-center mb-3">
                  <img
                    src={
                      theme === "dark"
                        ? "assets/images/development/software4-dark.svg"
                        : "assets/images/development/software4-light.svg"
                    }
                    alt="Logo"
                  />
                </div>
                <h5 className="heading_h5">Increased Control</h5>
                <p className="pera_txt">
                  Users’ assets are stored in non-custodial wallets, enabling
                  greater autonomy and control over assets.looking at
                  informative charts and graphs.
                </p>
              </motion.div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <motion.div
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
              >
                <div className="d-flex justify-content-center mb-3">
                  <img
                    src={
                      theme === "dark"
                        ? "assets/images/development/software5-dark.svg"
                        : "assets/images/development/software5-light.svg"
                    }
                    alt="Logo"
                  />
                </div>
                <h5 className="heading_h5">Transparency</h5>
                <p className="pera_txt">
                  DeFi’s Decentralized Autonomous Organization (DAO) augments
                  transparency.
                </p>
              </motion.div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <motion.div
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
              >
                <div className="d-flex justify-content-center mb-3">
                  <img
                    src={
                      theme === "dark"
                        ? "assets/images/development/software6-dark.svg"
                        : "assets/images/development/software6-light.svg"
                    }
                    alt="Logo"
                  />
                </div>
                <h5 className="heading_h5">Faster Settlement</h5>
                <p className="pera_txt">
                  DeFi applications can significantly reduce the settlement time
                  from T+1 to T+0, i.e. instantly.
                </p>
              </motion.div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <motion.div
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
              >
                <div className="d-flex justify-content-center mb-3">
                  <img
                    src={
                      theme === "dark"
                        ? "assets/images/development/software7-dark.svg"
                        : "assets/images/development/software7-light.svg"
                    }
                    alt="Logo"
                  />
                </div>
                <h5 className="heading_h5">Liquidity</h5>
                <p className="pera_txt">
                  DeFi promotes financial inclusion by enabling access to
                  financial services to the underbanked or unbanked population.
                </p>
              </motion.div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <motion.div
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
              >
                <div className="d-flex justify-content-center mb-3">
                  <img
                    src={
                      theme === "dark"
                        ? "assets/images/development/software8-dark.svg"
                        : "assets/images/development/software8-light.svg"
                    }
                    alt="Logo"
                  />
                </div>
                <h5 className="heading_h5">Innovation Enablement</h5>
                <p className="pera_txt">
                  DeFi’s open, permissionless, and programmable architecture
                  enables the creation of financial services and instruments
                  that meet users’ needs.
                </p>
              </motion.div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <motion.div
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="solution-box p-4 rounded-4 shadow-sm h-100 text-center"
              >
                <div className="d-flex justify-content-center mb-3">
                  <img
                    src={
                      theme === "dark"
                        ? "assets/images/development/software9-dark.svg"
                        : "assets/images/development/software9-light.svg"
                    }
                    alt="Logo"
                  />
                </div>
                <h5 className="heading_h5">Enhanced Security</h5>
                <p className="pera_txt">
                  Blockchain architecture ensures tamper proof, secure and
                  auditable data while bringing users on the safer side.
                </p>
              </motion.div>
            </div>
          </div>
        </div>
      </section>
      {/* ---------- Business Model section start ---------- */}
      <section className="space80">
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-6">
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="h-100"
              >
                <ImageWithSkeleton
                  src="assets/images/defi/defi-2.webp"
                  alt=""
                  className="w-100"
                />
                {/* <img
                  src="assets/images/defi/defi-2.webp"
                  alt=""
                  className="w-100 defi_img"
                /> */}
              </motion.div>
            </div>
            <div className="col-lg-6">
              <div>
                <motion.h3
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="heading_h3 fw-semibold"
                >
                  The Paradigm Shift From{" "}
                  <span className="text-primary fw-bold">
                    {" "}
                    Traditional Business Model{" "}
                  </span>{" "}
                  to DeFi Development
                </motion.h3>
                <motion.p
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="pera_txt"
                >
                  Are you a victim of numerous problems like delayed settlement
                  cycles, inefficient price discovery, liquidity challenges,
                  poor decision making, and the lack of assurance around
                  underlying assets that arise due to traditional approach to
                  finance? Decentralized Finance Development can eradicate these
                  issues.Whether you’re a unicorn startup or a Fortune 500
                  company, your future can be decentralized with DeFi blockchain
                  development. From maximized stakeholder control, superfast
                  settlement, improved auditability to minimized counterparty
                  risks, services of DeFi development company hold a huge
                  potential for emerging businesses and take them to the zenith.
                </motion.p>
                <motion.div
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="d-flex gap-3 flex-wrap"
                >
                  <button
                    class="button theme_btn px-xl-3 mt-2"
                    type="submit"
                  >
                    Connect on WhatsApp
                  </button>
                  <button
                    class="button theme_btn px-xl-3 mt-2"
                    type="submit"
                  >
                    Connect on Telegram
                  </button>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ---------- Development Global Market section start ---------- */}
      <section className="space60 services">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-6 order-lg-1 order-2">
              <div>
                <motion.h3
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="heading_h3 fw-semibold"
                >
                  Decentralized Finance{" "}
                  <span className="text-primary fw-bold">
                    {" "}
                    Development Global Market{" "}
                  </span>{" "}
                </motion.h3>
                <motion.applyp
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="pera_txt"
                >
                  At Blockcryp, we are always looking to the future of the digital
                  world, and the future is completely decentralized. The global
                  decentralized finance market size was valued at USD 13.61
                  billion in 2022 and is expected to expand CAGR of 46.0% from
                  2023 to 2030.
                </motion.applyp>
                <motion.p
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="pera_txt"
                >
                  As the DeFi platform development space continues to thrive,
                  organizations, including legacy financial institutions and
                  non-traditional entrants, can harness the potential of DeFi
                  development solutions to thrive in their businesses.
                </motion.p>
              </div>
            </div>
            <div className="col-lg-6 order-lg-2 order-1">
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="h-100"
              >
                <ImageWithSkeleton
                  src="assets/images/defi/global2.webp"
                  alt=""
                  className="w-100"
                  style={{ height: "500px" }}
                />
                {/* <img
                  src="assets/images/defi/global2.webp"
                  alt=""
                  className="w-100 defi_img"
                /> */}
              </motion.div>
            </div>
          </div>
        </div>
      </section>
      {/* ---------- DeFi Development Company section start ---------- */}
      <section className="space60">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-lg-6">
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className=""
              >
                <ImageWithSkeleton
                  src="assets/images/defi/approch2.webp"
                  alt=""
                  className="w-100"
                />
                {/* <img
                  src="assets/images/defi/approch2.webp"
                  alt=""
                  className="w-100"
                /> */}
              </motion.div>
            </div>
            <div className="col-lg-6">
              <div>
                <motion.h3
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="heading_h3 fw-semibold"
                >
                  Top-Tier{" "}
                  <span className="text-primary fw-bold">
                    {" "}
                    DeFi Development Company{" "}
                  </span>{" "}
                  with Result-Oriented Approach
                </motion.h3>
                <motion.p
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="pera_txt"
                >
                  Whether you are on the hunt for developing a public, private,
                  hybrid blockchain product or planning to get started with
                  flawless DeFi smart contract development, Blockcryp, being the
                  leading DeFi development company excels at providing reliable,
                  robust, and scalable solutions to a global clientele. With
                  over 500 projects launched and delivered successfully
                  worldwide, Blockcryp has emerged as the leading DeFi token
                  development company.
                </motion.p>
                {/* <motion.p initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }} className="pera_txt">
                  Blockcryp, being the best Defi Development Company has
                  straightforward vision- crafting blockchain solutions that are
                  intuitive, robust, user-friendly, scalable, and aesthetically
                  harmonious today, and beyond. We leverage agile methodology
                  backed by certified and skilled subject matter experts having
                  a knack for identifying what the modern and potential
                  customers need and expect from an offering.
                </motion.p> */}
                <motion.div
                  initial={{ opacity: 0, x: 50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.5 }}
                  viewport={{ once: false, amount: 0.5 }}
                  className=""
                >
                  <button
                    class="button theme_btn px-xl-3 mt-2"
                    type="submit"
                  >
                    Request a Free Demo
                  </button>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ---------- faq section start ---------- */}
      <section className="space40">
        <div className="container">
          <h2 className="heading_h3 fw-bold mb-4">
            Frequently Asked Questions
          </h2>
          <div className="row">
            <div className="col-12">
              <div className="accordion">
                <div
                  className={`accordion__item ${activeIndex === 0 ? "accordion__item--active" : ""
                    }`}
                >
                  <button
                    className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0"
                    onClick={() => toggleItem(0)}
                  >
                    <span className="text_20 pe-4">
                      1. How can I hire developers for my DeFi projects?
                    </span>
                    <span className="accordion__icon">
                      <i className="fa fa-plus" />
                    </span>
                  </button>
                  <div className="accordion__content">
                    <p className="p-2">
                      You can hire DeFi developers through blockchain agencies,
                      freelance platforms, or by partnering with specialized{" "}
                      <b> DeFi Development Companies </b> offering end-to-end
                      DeFi development and smart contract expertise.
                    </p>
                  </div>
                </div>
                <div
                  className={`accordion__item ${activeIndex === 1 ? "accordion__item--active" : ""
                    }`}
                >
                  <button
                    className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0"
                    onClick={() => toggleItem(1)}
                  >
                    <span className="text_20 pe-4">
                      2. How long does it take to develop DeFi Platforms?
                    </span>
                    <span className="accordion__icon">
                      <i className="fa fa-plus" />
                    </span>
                  </button>
                  <div className="accordion__content">
                    <p className="p-2">
                      <b> DeFi Platform Development </b> typically takes 2 to 6
                      months, depending on complexity, features, blockchain
                      integration, smart contract audits, frontend UI/UX design,
                      and post-launch support requirements.
                    </p>
                  </div>
                </div>
                <div
                  className={`accordion__item ${activeIndex === 2 ? "accordion__item--active" : ""
                    }`}
                >
                  <button
                    className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0"
                    onClick={() => toggleItem(2)}
                  >
                    <span className="text_20 pe-4">
                      3. What is DeFi and DeFi Development in simple terms?
                    </span>
                    <span className="accordion__icon">
                      <i className="fa fa-plus" />
                    </span>
                  </button>
                  <div className="accordion__content">
                    <p className="p-2">
                      DeFi offers decentralized financial services via
                      blockchain without banks. Whereas{" "}
                      <b> DeFi Development Services </b> involve building apps
                      like lending platforms or exchanges using smart contracts,
                      ensuring transparency, security, and user control.
                    </p>
                  </div>
                </div>
                <div
                  className={`accordion__item ${activeIndex === 3 ? "accordion__item--active" : ""
                    }`}
                >
                  <button
                    className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0"
                    onClick={() => toggleItem(3)}
                  >
                    <span className="text_20 pe-4">
                      4. What is the future outlook for DeFi in mainstream
                      finance?
                    </span>
                    <span className="accordion__icon">
                      <i className="fa fa-plus" />
                    </span>
                  </button>
                  <div className="accordion__content">
                    <p className="p-2">
                      In the upcoming time, DeFi is expected to merge with
                      traditional finance, offering decentralized access to
                      banking, trading, and investing, while evolving toward
                      regulation, scalability, and increased institutional
                      adoption globally.
                    </p>
                  </div>
                </div>
                <div
                  className={`accordion__item ${activeIndex === 4 ? "accordion__item--active" : ""
                    }`}
                >
                  <button
                    className="accordion__btn d-flex justify-content-between align-items-center border-0 outline-0 "
                    onClick={() => toggleItem(4)}
                  >
                    <span className="text_20 pe-4">
                      5. What blockchains are commonly used for DeFi
                      development?
                    </span>
                    <span className="accordion__icon">
                      <i className="fa fa-plus" />
                    </span>
                  </button>
                  <div className="accordion__content">
                    <p className="p-2">
                      Popular DeFi blockchains include Ethereum, BNB Chain,
                      Polygon, Solana, Avalanche, and Arbitrum, chosen for their
                      smart contract support, scalability, low fees, and strong
                      ecosystem of developer tools.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Solutions />
    </>
  );
}
